import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 30 30" {...props}>
      <path d="M15.0117 0.158752C6.72656 0.158752 0.0117188 6.8736 0.0117188 15.1588C0.0117188 23.4439 6.72656 30.1588 15.0117 30.1588C23.2969 30.1588 30.0117 23.4439 30.0117 15.1588C30.0117 6.8736 23.2969 0.158752 15.0117 0.158752ZM19.5117 16.6588H10.5117C9.68555 16.6588 9.01172 15.9849 9.01172 15.1588C9.01172 14.3326 9.68555 13.6588 10.5117 13.6588H19.5117C20.3379 13.6588 21.0117 14.3326 21.0117 15.1588C21.0117 15.9849 20.3379 16.6588 19.5117 16.6588Z" />
    </Svg>
  );
};

export default Icon;
